import { monthShort } from '../../lib/format';
import { useApi } from '../../lib/useApi';
import type { MonthState, OverviewResponse } from './types';

// Spalte „Belege“ der Mandantenliste: je Mandant das Abzeichen für den Fokus-Monat,
// z. B. { label: 'Sep · Beleg fehlt', tone: 'bad' }.
export type Tone = 'ok' | 'warn' | 'bad' | 'info' | 'none';

export function useBelegeOverview(): Record<string, { label: string; tone: Tone }> {
  const res = useApi<OverviewResponse>('/api/kanzlei/belege/overview', { live: ['belege', 'fristen'] });
  const out: Record<string, { label: string; tone: Tone }> = {};
  for (const c of res.data?.clients ?? []) {
    const s = focusPill(c.focus.state);
    out[c.clientId] = { label: `${monthShort(c.focus.month)} · ${s.label}`, tone: s.tone };
  }
  return out;
}

// Stand des Fokus-Monats, Wörter und Farben wie im Tab „Belege vom Mandanten“. Der aktuelle Monat ohne Belege
// heißt in der Kanzlei „offen“ (orange), nur die App sagt „läuft“.
export function focusPill(state: MonthState): { label: string; tone: Tone } {
  switch (state) {
    case 'gebucht':
      return { label: 'gebucht', tone: 'ok' };
    case 'nachtrag':
      return { label: 'Nachtrag', tone: 'info' };
    case 'fehlt':
      return { label: 'Beleg fehlt', tone: 'bad' };
    case 'nachgereicht':
      return { label: 'nachgereicht', tone: 'info' };
    case 'hochgeladen':
      return { label: 'hochgeladen', tone: 'info' };
    case 'offen':
    case 'laeuft':
      return { label: 'offen', tone: 'warn' };
    default:
      return { label: '–', tone: 'none' };
  }
}

// Lücke = Zelle rot oder orange („Beleg fehlt“ oder „offen“, auch der aktuelle Monat ohne Belege). Für die Kennzahl.
export const isGap = (state: MonthState) => state === 'fehlt' || state === 'offen' || state === 'laeuft';
